import {
  MODAL_ACTION,
  useModalsContext,
  DestinationFormProvider,
  SendTestPushFormProvider,
} from 'modules/sendingPlatforms/contexts';
import { SendTestPushModal } from './Modals/SendTestPushModal';
import { DestinationTakeover } from './Modals/DestinationTakeover';
import { DeleteDestinationModal } from './Modals/DeleteDestinationModal';

export const CustomPushModals = () => {
  const { modalState } = useModalsContext();

  if (modalState === null) return null;
  const { action } = modalState;

  switch (action) {
    case MODAL_ACTION.ADD_DESTINATION:
      return (
        <DestinationFormProvider>
          <DestinationTakeover />
        </DestinationFormProvider>
      );

    case MODAL_ACTION.DELETE_DESTINATION:
      return <DeleteDestinationModal />;

    case MODAL_ACTION.SEND_TEST_PUSH:
      return (
        <SendTestPushFormProvider>
          <SendTestPushModal />
        </SendTestPushFormProvider>
      );

    default:
      return null;
  }
};
